const CardSkeleton = () => (
    <div className="col-xs-12 col-sm-6 col-md-4">
        <div className="skeleton">
            <div className="img" />
            <div className="heading" />
            <div className="price" />
            <div className="detail" />
        </div>
    </div>
);


export default CardSkeleton;
